import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import useMount from '@src/utils/hooks/use-mount';
import { getOmniData, Ids } from '@src/services/omni-api';

const DEFAULT_RULE_CONFIG = {
  title: '活动规则',
  subTitle: '上线瓜分50万现金红包',
  date: '活动时间：2026年10月15日~11月15日',
  rules: [
    '2026年10月15日公测开启后，游戏内开启福袋有机会瓜分50万现金红包。',
    '2026年10月15日公测开启后，游戏内开启福袋有机会瓜分50万现金红包。',
    '最大单个红包金额为5万元。红包可提现为现金。'
  ]
};

const normalizeText = (value, fallback) => {
  const text = typeof value === 'string' ? value.trim() : '';
  return text || fallback;
};

class GiftRuleModalStore extends BaseModalStore {
  @observable closeCallback = noop;
  @observable ruleConfig = DEFAULT_RULE_CONFIG;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  loadRuleConfig = async () => {
    const { channel, dataSources } = Ids.giftRule;

    try {
      const res = await getOmniData(channel, [{ dataSourceId: dataSources.rule, page: 1, perPage: 1 }]);
      const item = res?.[dataSources.rule]?.result?.items?.[0];
      if (!item) return;

      let rules = [];
      if (typeof item.rule === 'string') {
        rules = item.rule
          .split(/\r?\n/)
          .map(rule => rule.trim())
          .filter(Boolean);
      }
      this.ruleConfig = {
        title: normalizeText(item.title, DEFAULT_RULE_CONFIG.title),
        subTitle: normalizeText(item.sub_title, DEFAULT_RULE_CONFIG.subTitle),
        date: normalizeText(item.date, DEFAULT_RULE_CONFIG.date),
        rules: rules.length ? rules : DEFAULT_RULE_CONFIG.rules
      };
    } catch (error) {
      // Keep the local copy visible when Omni is temporarily unavailable.
      console.error('Failed to load gift rule config', error);
    }
  };

  use() {
    // 只预取配置；弹窗仍由首页入口手动控制。
    useMount(this.loadRuleConfig);
  }
}

export default GiftRuleModalStore;
